import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-info-group">
          <div className="footer-section address-section">
            <h3>Our Location</h3>
            <p className="address">
              1E, 5 Ceres Court<br />
              Rosedale, North Shore City<br />
              Auckland, 0632
            </p>
          </div>

          <div className="footer-section contact-section">
            <h3>Contact Us</h3>
            <p className="phone" style={{ fontSize: '16px', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.9)' }}>
              Phone: <a href="tel:+64204440991" style={{ color: 'white', textDecoration: 'none', fontWeight: 'bold' }}>+64 204440991</a>
            </p>
          </div>
        </div>
        
        <div className="footer-section partners-section">
          <h3>Our Partners</h3>
          <div className="partner-logos">
            <a href="https://www.charteredaccountantsanz.com/" target="_blank" rel="noopener noreferrer" className="partner-logo">
              <img src="/images/ca-logo.png" alt="CA" />
            </a>
            <a href="https://www.cpaaustralia.com.au/" target="_blank" rel="noopener noreferrer" className="partner-logo">
              <img src="/images/cpa-logo.jpg" alt="CPA" />
            </a>
            <a href="https://www.xero.com/nz/" target="_blank" rel="noopener noreferrer" className="partner-logo">
              <img src="/images/xero-logo.png" alt="Xero" />
            </a>
            <a href="https://www.myob.com/nz" target="_blank" rel="noopener noreferrer" className="partner-logo">
              <img src="/images/myob-logo.png" alt="MYOB" />
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Growbal. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
